/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchSpeakers } from '../services/graphqlService';
import { fetchSmartCrops } from '../utils/dynamicMedia';

const SpeakersContext = createContext();

const fetchSpeakersWithImages = async () => {
  const data = await fetchSpeakers();
  const items = data?.data?.speakersList?.items || data?.data?.connectSpeakerList?.items || [];
  
  return Promise.all(items.map(async (speaker) => {
    const dmUrl = speaker.image1?._dmS7Url;
    const crops = dmUrl ? await fetchSmartCrops(dmUrl) : null;
    
    return {
      ...speaker,
      smartCrops: crops
    };
  }));
};

export const SpeakersProvider = ({ children }) => {
  const { data: speakers = [], isLoading: loading } = useQuery({
    queryKey: ['speakers'],
    queryFn: fetchSpeakersWithImages,
    staleTime: 15 * 60 * 1000, // 15min
  });

  return (
    <SpeakersContext.Provider value={{ speakers, loading }}>
      {children}
    </SpeakersContext.Provider>
  );
};

export const useSpeakers = () => {
  const context = useContext(SpeakersContext);
  if (!context) {
    throw new Error('useSpeakers must be used within SpeakersProvider');
  }
  return context;
};
